// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"90d32ace","688":"50037716"}[chunkId] + ".chunk.css";
};